import { RoadsideProduct } from "CommonTypes";
import { Datoblock } from "./Types";

type RoadsideProductComparisonText = {
    [key in RoadsideProduct]: string;
};

interface CoverSelectionComparisonTableRow extends RoadsideProductComparisonText {
    id: string;
    title: string;
}

type RoadsideProductComparisonOtherBenefitsChecked = {
    [key in RoadsideProduct]: boolean;
};

interface CoverSelectionComparisonTableOtherBenefitsRow extends RoadsideProductComparisonOtherBenefitsChecked {
    id: string;
    title: string;
}

export interface CoverSelectionQueryResponse {
    roadside?: {
        coverSelectionIntroText: Datoblock;
        coverSelectionAlertBoxWarn: Datoblock;
        coverSelectionAlertBoxInfo: Datoblock;
        coverSelectionComparisonTableRows: CoverSelectionComparisonTableRow[];
        comparisonTableOtherBenefits: CoverSelectionComparisonTableOtherBenefitsRow[];
    };
}

export const CoverSelectionQuery = `
{
    roadside {
        coverSelectionIntroText {
            blocks
            links
            value
        },
        coverSelectionComparisonTableRows {
            id
            title: compTableRowTitle
            Advantage: compTableAdvantageText
            Ultimate: compTableUltimateText
        },
        comparisonTableOtherBenefits {
            id
            title: benefitTitle
            Advantage: advantageBenefit
            Ultimate: ultimateBenefit
        }
        coverSelectionAlertBoxWarn {
            blocks
            links
            value
        }
        coverSelectionAlertBoxInfo {
            blocks
            links
            value
        }
    }
}
`;
